import { useAuthorize } from '@/shared/authorization/useAuthorize';
import { useFeatureFlags } from '@/shared/hooks/use-feature-flags';
import { useClientName } from '@/shared/hooks/useClientName';

import type { NavGateContext } from './nav-tree';

/** The role/flags/tenant context nav `handle.gate`s evaluate against. */
export const useNavGateContext = (): NavGateContext => {
  const { role } = useAuthorize();
  const flags = useFeatureFlags();
  const { isLiaFcs } = useClientName();

  return { role, flags, isLiaFcs };
};
